
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regala-una-degustazione",
      function () {
        return require("private-next-pages/regala-una-degustazione.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regala-una-degustazione"])
      });
    }
  